<template>
    <div class="w-100 position-relative">
      <div v-if="!is_in_searcher">
        <search @changeNetwork="changeNetwork" @open_side_summary="openSummaryProfile"></search>
      </div>

      <b-row class="mb-05">
        <b-col class="col-12 col-lg-12">
          <div class="featured-header">
            <div class="featured-header__left">
              <h4 class="text-left d-flex align-items-center m-0 break-word">
                {{ $t('creator.featuredPicks') }}
                <span class="text-country" v-if="!focus_name_country" @click="focus_name_country = true">
                  {{country.name}}
                  <feather-icon icon="ChevronDownIcon" size="14" class="ml-25" />
                </span>
              </h4>
              <span class="featured-hint">
                <span class="featured-hint__icon">💡</span>
                {{ $t('creator.changeLocationHint', { name: country.name }) }}
              </span>
            </div>
          </div>
          <!-- selector de país: fuera del header para no mover el hint -->
          <div v-if="focus_name_country" class="country-picker-row">
            <div v-for="(location, index) in audience_locations" :key="index">
              <audience-location-filter
                ref="audience_location_filter"
                :key="change_audience_location"
                :show_remove="false"
                :show_slider="false"
                :index="index"
                :location="location"
                :only_countries="true"
                :show_reset_location="false"
                :show_loader="false"
                :is_in_analyzer="true"
                @changeLocationAudienceChild="changeLocationAudience"
                @blur_action="blurActionSuggestion"
              />
            </div>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <div class="container-loader-searcher" v-if="loader_location">
          <b-spinner class="spinner-table-searcher"></b-spinner>
        </div>
        <b-col class="col-12 col-lg-6 mt-1" v-for="card in cards" :key="card.hash" @click="searcher(card)">
          <card-secondary
            class="cursor-pointer"
            :textInfo="card.slug"
            :mention="card.title"
            :colorCard="card.color"
            :images="card.avatars"
            :country_name="country.name"
            :country_flag="getFlagEmoji(country.name)"
          >
          </card-secondary>
        </b-col>
        
      </b-row>

      <sidebar-search-new
        :open_sidebar="open_sidebar" 
        :key="update_sidebar" 
        :username="data_sidebar"
        :network="select_network"
        class="open-sidebar-search"
        v-if="open_sidebar"
      >
      </sidebar-search-new>
    </div>
</template>

<script>
import {
  BSpinner,
  BRow,
  BCol,
} from "bootstrap-vue";
import { getUrlCategory } from '@/libs/utils/urls';
import { getMainInfluencers } from '@/services/search'
const countriesData = require('@/libs/countries.json')

function getFlagEmoji(countryName) {
  if (!countryName) return ''
  const normalize = s => s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim()
  const norm = normalize(countryName)
  const found = countriesData.find(c => normalize(c.name) === norm)
  if (!found) return ''
  const code = found['alpha-2'].toUpperCase()
  return code.split('').map(c => String.fromCodePoint(0x1F1E6 - 65 + c.charCodeAt(0))).join('')
}
const loadToastificationContent = () => import('@core/components/toastification/ToastificationContent.vue');

export default {
  name: 'analyzerDashboard',
  components: {
    BSpinner,
    BRow,
    BCol,
    Search: () => import('@/views/search/search.vue'),
    cardSecondary: () => import('@/views/pages/analyzer/cardSecondary.vue'),
    AudienceLocationFilter: () => import('@/views/buscador/filters/audience_locations.vue'),
    SidebarSearchNew: () => import('@/views/buscador/SidebarSearchNew.vue'),
  },
  data() {
    return {
      getFlagEmoji,
      loader_location: false,
      network: {value: 'instagram', id: '1'},
      networks: [
        {value: 'instagram', id: '1'},
        {value: 'tiktok', id: '3'},
        {value: 'twitter', id: '5'},
        {value: 'youtube', id: '2'},
        {value: 'twitch', id: '4'}
      ],
      sort_options: [
        {key: 'most_followed', sort_type: 'fc', sort_order: 'desc'},
        {key: 'fast_growing', sort_type: 'sbs_grth', sort_order: 'desc'},
        {key: 'most_commented', sort_type: 'cr', sort_order: 'desc'},
        {key: 'influencers', sort_type: 'fc', sort_order: 'desc'},
        {key: 'best_quality', sort_type: 'er', sort_order: 'desc'},
        {key: 'best_quality_2', sort_type: 'aqs', sort_order: 'desc'},
        {key: 'most_liked', sort_type: 'likes', sort_order: 'desc'},
        {key: 'fast_growing_women', sort_type: 'sbs_grth', sort_order: 'desc'},
        {key: 'fast_growing_men', sort_type: 'sbs_grth', sort_order: 'desc'},
        {key: 'most_er', sort_type: 'er', sort_order: 'desc'},
        {key: 'most_viewed', sort_type: 'pv_a', sort_order: 'desc'},
        {key: 'most_streamed', sort_type: 'hours_streamed', sort_order: 'desc'},
        {key: 'most_viewed_4', sort_type: 'live_viewers_avg', sort_order: 'desc'},
      ],
      getUrlCategory,
      main_country: 3996063,
      cards: [],
      update_location: false,
      audience_locations: [{}],
      change_audience_location: false,
      main_influencers: [],
      country: {
        id: 3996063,
        name: 'México',
        type: 0
      },
      focus_name_country: false,
      open_sidebar: false,
      update_sidebar: 0,
      data_sidebar: '',
      select_network: 'instagram'
    }
  },
  props: {
    is_in_searcher: {
      type: Boolean,
      default: false,
    }
  },
  created() {
    this.cards = [];
    this.getMainInfluencers()
  },
  destroyed() {
  },
  methods: {
    openSummaryProfile(item) {
      this.data_sidebar = item.type !== 'youtube' ? item.username : item.channel_id;
      this.select_network = item.type;
      this.open_sidebar = true;
      this.update_sidebar += 1;
    },
    blurActionSuggestion() {
      this.focus_name_country = false;
    },
    changeNetwork(network) {
      const found = this.networks.find(i => i.value === network)
      if (!found) return
      this.network = found
      this.getMainInfluencers()
    },
    changeLocationAudience(data) {
      this.country = data.location
      this.getMainInfluencers()
      this.focus_name_country = false;
    },
    _cacheKey() {
      return `dashboard_influencers_${this.country.id}`
    },
    _getCache() {
      const TTL = 10 * 60 * 1000 // 10 min
      try {
        const raw = localStorage.getItem(this._cacheKey())
        if (!raw) return null
        const { data, ts } = JSON.parse(raw)
        if (Date.now() - ts > TTL) { localStorage.removeItem(this._cacheKey()); return null }
        return data
      } catch (e) { return null }
    },
    _setCache(data) {
      try {
        localStorage.setItem(this._cacheKey(), JSON.stringify({ data, ts: Date.now() }))
      } catch (e) { /* storage no disponible */ }
    },
    getMainInfluencers() {
      const cached = this._getCache()
      if (cached) {
        // Muestra caché de inmediato sin loader
        this.main_influencers = cached
        this.formatCards()
        // Revalida en background silenciosamente
        getMainInfluencers(this.country.id).then(response => {
          if (!response.error) {
            this._setCache(response.searches)
            this.main_influencers = response.searches
            this.formatCards()
          }
        })
        return
      }
      this.loader_location = true;
      getMainInfluencers(this.country.id).then(response => {
        if (response.error) {
          loadToastificationContent().then((component) => {
            this.$toast({
              component: component.default,
              position: 'top-right',
              props: {
                title: this.$t('campaigns.error_status'),
                icon: 'CoffeeIcon',
                variant: 'danger',
                text: this.$t('search.workingIssue')
              }
            })
          })
          this.loader_location = false;
          return;
        }
        this._setCache(response.searches)
        this.main_influencers = response.searches
        this.formatCards()
      })
    },
    formatCards() {
      const palette = [
        'linear-gradient(135deg,#1e3a5f,#2563eb)',
        'linear-gradient(135deg,#065f46,#10b981)',
        'linear-gradient(135deg,#4c1d95,#8b5cf6)',
        'linear-gradient(135deg,#7c2d12,#f97316)',
      ];
      this.cards = [];
      (this.main_influencers[this.network.id] || []).forEach((item, index) => {
        this.cards.push({ ...item, color: palette[index % palette.length] });
      });
      this.loader_location = false;
    },
    searcher(card) {
      const exist_locations = Object.keys(card.search).find(k => k === 'audience_location')

      if (exist_locations) {
        card.search['audience_location'][0]['name'] = this.country.name
        card.search['audience_location'][0]['id'] = this.country.id
      }

      const exist_influencer_locations = Object.keys(card.search).find(k => k === 'influencer_location')

      if (exist_influencer_locations) {
        card.search['influencer_location'][0]['name'] = this.country.name
        card.search['influencer_location'][0]['id'] = this.country.id
      }

      let slug = card.slug

      if (this.network.id === '4' && slug === 'most_viewed') slug = `${slug}_4`
      if (this.network.id === '2' && slug === 'best_quality') slug = `${slug}_2`

      const sort = this.sort_options.find(s => s.key === slug)

      if (sort) {
        card.search['sort_type'] = sort.sort_type
        card.search['sort_order'] = sort.sort_order
      } else {
        card.search['sort_type'] = 'sbs_grth'
        card.search['sort_order'] = 'desc'
      }
      const search = JSON.stringify(card.search);

      const hash = btoa(search);

      this.$router.push({name: 'auth-search', query: {hash}}).catch(() => {});
    }
  },
} 
</script>

<style scoped>
.container-loader-searcher {
  height: 100%;
  width: 100%;
  position: absolute;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 100;
  top: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.spinner-table-searcher {
  height: 6em;
  width: 6em;
  color: #acacac;
}
.text-country {
  color: var(--primary-for-blue-cases, #007bff);
  cursor: pointer;
  margin: 0em 0.2em 0 0.3em;
}
.mb-05 {
  margin-bottom: .5em;
}
.featured-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
}
.featured-header__left {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.featured-hint {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  color: #9ca3af;
  background: #f3f4f6;
  padding: 2px 8px 2px 6px;
  border-radius: 20px;
  line-height: 1;
}
.featured-hint__icon {
  font-size: 12px;
}
.country-picker-row {
  margin-top: 6px;
}
</style>